import { CerebralError } from 'cerebral'

export class ApiError extends CerebralError {}